import React, { useEffect, useRef, useState } from 'react';

import EditMediaPopup from './EditMediaPopup';
import Loader from '../Loader/Loader';
import DeleteConfirmationPopup from '../DeleteConfirmationPopup';

import fileDocIcon from "../../assets/images/file-doc-icon.svg";
import fileVideoIcon from "../../assets/images/file-video-icon.svg";
import { deleteMedia, uploadMedia } from '../../api/mediaApi';

const GridLayout = ({ userMedia, setUserMedia, selectedItems, setSelectedItems, isLoadingData }) => {
    const deletePopupRef = useRef();
    const usePopupRef = useRef();
    const [showPopup, setShowPopup] = useState(false);
    const [editedItemId, setEditedItemId] = useState(null);
    const [isDelLoading, setDelIsLoading] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const mediaIconSet = {
        'application/doc': fileDocIcon,
        'video/mp4': fileVideoIcon,
        'video/mpeg': fileVideoIcon,
        'video/ogg': fileVideoIcon,
        'video/webm': fileVideoIcon,
        'video/3gpp': fileVideoIcon,
        'video/3gpp2': fileVideoIcon,
        'video/x-msvideo': fileVideoIcon,
        'video/quicktime': fileVideoIcon,
    }

    const handleCheckboxChange = (itemId) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(itemId)) {
                const updatedSelectedItems = prevSelectedItems.filter((id) => id !== itemId);
                return updatedSelectedItems;
            } else {
                const updatedSelectedItems = [...prevSelectedItems, itemId];
                return updatedSelectedItems;
            }
        });
    };

    const handleEditClick = (itemId) => {
        setShowPopup(true)
        setEditedItemId(itemId);
    };

    const maxSizeInBytes = 128 * 1024 * 1024; // 128MB
    const [isImageDragging, setIsImageDragging] = useState(false);
    const [errorMessages, setErrorMessages] = useState([])
    const allowFIleType = {
        '^image/': 'Images',
        '^video/': 'Videos',
    }

    const handleGalleryImageDrop = async (e) => {
        if (!showPopup) {
            e.preventDefault();
            let newErrorMessages = [];
            setErrorMessages([]);
            setIsImageDragging(false);
            const files = e.dataTransfer.files;

            for (const file of files) {
                const isAllowedFileType = Object.keys(allowFIleType).some((pattern) => new RegExp(pattern).test(file.type));

                if (!isAllowedFileType) {
                    const errorMessage = 'This file type is not supported';
                    newErrorMessages.push(errorMessage);
                }

                if (file.size > maxSizeInBytes) {
                    
                    continue; // Skip this file
                }

                setErrorMessages(newErrorMessages)

                // Stable local identifiers
                const tempId = Date.now() + Math.random();
                const mediaIndex = Math.floor(Math.random() * (9999 - 1111 + 1)) + 1111;

                const placeholderMedia = {
                    id: tempId,          // local temp id
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    url: '',
                    createdAt: '',
                    index: mediaIndex,
                    isLoading: true,
                    isError: false
                };

                setUserMedia((prevUserMedia) => [placeholderMedia, ...prevUserMedia]);

                try {
                    // 2️⃣ Upload
                    const uploadedMediaData = await uploadMedia(file, mediaIndex);
    
                    // 3️⃣ Update placeholder on success
                    setUserMedia((prev) =>
                        prev.map((media) =>
                            media.id === tempId
                                ? {
                                    ...media,
                                    ...uploadedMediaData,
                                    isLoading: false
                                }
                                : media
                        )
                    );
                } catch (error) {
                    console.error('Upload failed:', error);
    
                    newErrorMessages.push(
                        `Failed to upload ${file.name}`
                    );
    
                    // 4️⃣ Remove placeholder on failure
                    setUserMedia((prev) =>
                        prev.filter((media) => media.id !== tempId)
                    );
                }

                if (newErrorMessages.length) {
                    
                    setErrorMessages && setErrorMessages(newErrorMessages);
                }
            }

            setIsImageDragging(false);
            setErrorMessages(newErrorMessages);
        }
    };

    const handleFileDragOver = (e) => {
        e.preventDefault();
    }

    const handleFileDragLeave = (e) => {
        e.preventDefault();
        setIsImageDragging(false);
    };

    const confirmDelete = async() => {
        try {
            setDelIsLoading(true);

            await deleteMedia([editedItemId]);

            const updatedUserMedia = userMedia.filter(media => media.id !== editedItemId);
            setUserMedia(updatedUserMedia);
            setEditedItemId(null)

            setDelIsLoading(false);
            setDeleteConfirmation(false);
            setShowPopup(false);
        } catch (error) {
            setDelIsLoading(false);
            console.log(error)
        }
    };

    useEffect(() => {
        const checkIfClickedOutside = (e) => {
            // 1. If delete popup is open → handle ONLY delete popup
            if (deleteConfirmation) {
                if (
                    deletePopupRef.current &&
                    !deletePopupRef.current.contains(e.target)
                ) {
                    setDeleteConfirmation(false);
                }
                return; // ⛔ STOP HERE
            }

            // 2. Only handle Edit popup if delete popup is NOT open
            if (
                showPopup &&
                usePopupRef.current &&
                !usePopupRef.current.contains(e.target)
            ) {
                setShowPopup(false);
            }
        };

        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [deleteConfirmation, showPopup]);


    return (
        <div className={(isImageDragging && !showPopup) ? 'grid-container media-grid-layout draging' : 'grid-container media-grid-layout '} onDragOver={handleFileDragOver}
            onDragLeave={handleFileDragLeave}
            onDrop={handleGalleryImageDrop}>
            {isLoadingData ?
                <div className="loading-list">
                </div>
                :
                <>
                    {(userMedia && userMedia?.length > 0) ?
                        <div className="gridIitem">
                            {userMedia?.map((media) => (
                                <div className={`gridImg ${(media.type).includes('image') ? 'type-image' : 'type-doc'}`} key={media?.id}>
                                    {media?.isLoading ?
                                        <div className="uploadPicture">
                                            <Loader />
                                        </div>
                                        :
                                        <>
                                            <img src={mediaIconSet[media.type] ? mediaIconSet[media.type] : media?.url} onClick={() => handleEditClick(media?.id)} alt={media?.name} className='item' />

                                            {(!(media?.type).includes('image')) && <div className='itemName'> {media?.name} </div>}

                                            <input type="checkbox" checked={selectedItems.includes(media?.id)} onChange={() => handleCheckboxChange(media?.id)} />
                                        </>
                                    }
                                </div>
                            ))}

                            {showPopup &&
                                <EditMediaPopup showPopup={showPopup} setShowPopup={setShowPopup} item={userMedia.find(item => item?.id === editedItemId)} userMedia={userMedia} setUserMedia={setUserMedia} setDeleteConfirmation={setDeleteConfirmation} usePopupRef={usePopupRef} />
                            }
                            <DeleteConfirmationPopup
                                showDeletePopup={deleteConfirmation}
                                reference={deletePopupRef}
                                confirmDelete={confirmDelete}
                                setShowDeletePopup={setDeleteConfirmation}
                                onCancel={() => setDeleteConfirmation(false)}
                                title={'Media'}
                                isLoading={isDelLoading}
                                description={`Are you sure you want to delete this media? This action cannot be undone.`}
                            />
                        </div>
                        :
                        <>
                        No Data Found!
                        </>
                    }
                    {errorMessages && errorMessages.length > 0 && (
                        <div className="errorMessages">
                            {errorMessages.map((errorMessage, index) => (
                                <>
                                    <p key={index} className="error-message" >{errorMessage}</p>
                                </>
                            ))}
                        </div>
                    )}
                </>

            }

        </div>
    );
};

export default GridLayout;